export const FIXED_TICK_MS = 100;
export const MS_PER_GAME_DAY = 180_000;
export const HOURS_PER_DAY = 24;
export const MINUTES_PER_HOUR = 60;
export const MINUTES_PER_DAY = HOURS_PER_DAY * MINUTES_PER_HOUR; // 1.440 menit

export const MS_PER_GAME_MINUTE = MS_PER_GAME_DAY / MINUTES_PER_DAY; // Tepat 125 ms
export const MS_PER_GAME_HOUR = MS_PER_GAME_MINUTE * MINUTES_PER_HOUR; // Tepat 7.500 ms
export const START_HOUR = 8;
export const START_OFFSET_MS = START_HOUR * MS_PER_GAME_HOUR; // 60.000 ms (08:00)

export interface GameDate {
  day: number;
  hour: number;
  minute: number;
}

/**
 * Mengonversi akumulasi totalGameMs menjadi Hari (mulai dari 1), Jam (0..23), dan Menit (0..59).
 * Saat totalGameMs = 0 -> Hari 1, 08:00.
 * Saat totalGameMs = 120.000 (16 jam kemudian) -> Hari 2, 00:00.
 */
export function getGameDate(totalGameMs: number): GameDate {
  const safeMs = Math.max(0, Math.trunc(totalGameMs));
  const shiftedMs = safeMs + START_OFFSET_MS;

  const day = Math.floor(shiftedMs / MS_PER_GAME_DAY) + 1;
  const msInCurrentDay = shiftedMs % MS_PER_GAME_DAY;
  const hour = Math.floor(msInCurrentDay / MS_PER_GAME_HOUR);
  const minute = Math.floor((msInCurrentDay % MS_PER_GAME_HOUR) / MS_PER_GAME_MINUTE);

  return { day, hour, minute };
}

/**
 * Menghasilkan string tampilan HUD seperti "Hari 1 — 08:00"
 */
export function formatGameDate(totalGameMs: number): string {
  const { day, hour, minute } = getGameDate(totalGameMs);
  const hh = String(hour).padStart(2, '0');
  const mm = String(minute).padStart(2, '0');
  return `Hari ${day} — ${hh}:${mm}`;
}

